module.exports = __webpack_public_path__ + "img/coat.1c094aa.svg";